import React from 'react';
import PropTypes from 'prop-types';

import RadioLabel from '../label/Label';
import { COUPON_TYPES } from '../../../constants';

const RadioCampaign = ({ coupons, selectedCoupon, onChange, hideNoSelected }) => {
  return (
    <div className="radio radioCampaign">
      {!hideNoSelected && (
        <div className="radioItem" onClick={() => onChange(undefined)}>
          <input type="radio" name="radio-coupon" className="radio-input" id="radio-coupon-no-selected" checked={!selectedCoupon} readOnly />
          <label htmlFor="radio-coupon-no-selected">
            <div className="radioLabelText">利用しない</div>
          </label>
        </div>
      )}
      {coupons.map((c) => {
        const { id, name, type, goto, totalDiscount } = c;
        const checked = !!selectedCoupon && selectedCoupon.id === id;
        const isDiscount = type === COUPON_TYPES.discount;
        const labelName = isDiscount ? '割引' : 'クーポン';
        const labelColor = isDiscount ? 'red' : 'blue';

        const isCommunitySupport = goto && goto.communitySupport;

        const firstKey = isCommunitySupport ? '①割引' : '全国旅行支援';
        const secondKey = isCommunitySupport ? '②割引' : 'その他割引';

        const nameDisplay = goto ? (
          <div style={{ display: 'inline-block' }}>
            {`${totalDiscount.toLocaleString()}円引き: ${name}`}
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <div className="radioLabelText" style={{ display: 'flex' }}>
                <div style={{ paddingRight: 5 }}>
                  {'<内訳>'}
                </div>
                <div>
                  {`${firstKey} : ${goto.gotoDiscount.toLocaleString()}円`}<br/>
                  {`${secondKey} : ${goto.areaDiscount.toLocaleString()}円`}
                </div>
              </div>
              <RadioLabel color={labelColor} labelSize="min">{labelName}</RadioLabel>
            </div> 
          </div>
        ) : (
          <React.Fragment>
            <div className="radioLabelText">{name}</div>
            <RadioLabel color={labelColor} labelSize="min">{labelName}</RadioLabel>
          </React.Fragment>
        );

        return (
          <div className="radioItem" key={id} onClick={() => onChange(c)}>
            <input type="radio" name="radio-coupon" className="radio-input" id={id} checked={checked} readOnly />
            <label htmlFor={id}>
              {nameDisplay}
            </label>
          </div>
        );
      })}
    </div>
  );
};

RadioCampaign.propTypes = {
  coupons: PropTypes.array.isRequired,
  selectedCoupon: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  hideNoSelected: PropTypes.bool,
};

export default RadioCampaign;
